(function () {
  function initJojoListingProduct(root) {
    if (!root || root.dataset.jojoProductReady === 'true') return;
    root.dataset.jojoProductReady = 'true';

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-jojo-product-card]');
      if (!card || !root.contains(card)) return;
      event.preventDefault();
      var flipped = card.classList.toggle('is-flipped');
      card.setAttribute('aria-pressed', flipped ? 'true' : 'false');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-jojo-listing-product]').forEach(initJojoListingProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-jojo-listing-product]')
      : null;
    if (root) {
      root.dataset.jojoProductReady = 'false';
      initJojoListingProduct(root);
    }
  });
})();
